import React from 'react';
import PropTypes from 'prop-types';

import { API_URL } from 'utils/env/client';
import { track } from 'utils/analytics';
import { useClassName } from 'common/hooks';

import googleWalletLogo from 'common/assets/google-wallet.svg';
import './wallet-button.less';

function shouldRender() {
  return ['Android'].some((environment) =>
    navigator.userAgent.toLowerCase().includes(environment.toLowerCase())
  );
}

function GoogleWalletButton({ orderId, ticketIds, alwaysVisible }) {
  const classNames = useClassName('WalletButton');
  const query = ticketIds?.length ? `?ticketIds=${ticketIds.join(',')}` : '';

  const onClick = () => {
    track('Add to Wallet - Google - Success');
  };

  if (!alwaysVisible && !shouldRender()) return null;
  return (
    <div className={classNames('container')}>
      <a
        href={`${API_URL}/1/passkit/download-google/${orderId}${query}`}
        target="_blank"
        onClick={onClick}
        rel="noreferrer">
        <img src={googleWalletLogo} alt="logo" style={{ width: 160 }} />
      </a>
    </div>
  );
}

GoogleWalletButton.propTypes = {
  orderId: PropTypes.string,
  ticketIds: PropTypes.arrayOf(PropTypes.string),
  alwaysVisible: PropTypes.bool,
};

export default GoogleWalletButton;
